import moment from 'moment-timezone';
import React, { useEffect } from "react";
import Accordion from 'react-bootstrap/Accordion';
import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import Container from "react-bootstrap/Container";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useRouter } from "util/router";
import Image from 'react-bootstrap/Image';
import analytics from 'util/analytics';
import "./ClassList.scss";
import Section from "./Section";
import {wakeupCheckout} from 'util/api/CheckoutAPI'
import {useAuth} from 'util/auth'
import {fetchOndemand} from 'store/actions/widgetActions'
import PreviewImage from 'components/PreviewImage'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import { useForm, Controller } from "react-hook-form"
import Form from 'react-bootstrap/Form'
import CustomReactSelect from 'components/Store/CustomReactSelect';
import {useChallenge} from 'util/challengeWidgetProvider'
import Spinner from 'react-bootstrap/Spinner';
import _ from 'lodash'
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function ClassCard(props) {

    const {full} = props
    const {hostData, studioMode} = props

    const actionButtonText = props.reservation ? "View" : (full ? "Full" : "Sign Up")

    if (props.type && props.type === 'event') {
        return (
            <Card key={props.platformID} border='transparent' className='text-left p-0' style ={{width: '100%'}}>
                <Card.Body className='p-0'>
                    
                    <div className="row">
                        <div className="col-sm-12 col-md-4 mb-2">
                            <PreviewImage imageUrl={props.image} />    
                        </div>
                        <div className="col-sm-12 col-md-8">
                            <div className="d-flex flex-column justify-content-between h-100">
                                <div>
                                    <h3>{props.name || props.class_name}</h3>
                                    <h6>{props.datetime}</h6>
                                    <Card.Text className="m-0 p-0 mb-2">
                                        {props.location}
                                    </Card.Text>
                                    <Card.Text className="m-0 p-0 mb-2">
                                        {props.description}
                                    </Card.Text>
                                </div>
                                <Button className="primaryColor" style={{"whiteSpace": "nowrap", "width": "120px"}} onClick={props.clickHandler}>{actionButtonText}</Button>
                            </div>
                            
                        </div>
                    </div>
                </Card.Body>
                {props.showDivider && (
                    <hr />
                )}
            </Card>
        )
    }

    const classExtraDescription = (<>
        <Card.Text className="mt-3">
            {props.description}
        </Card.Text>
        {/* JARCH: do something here about host_data */}
        {hostData && hostData.map((val, idx) => {
            if (studioMode || val.specialGuest) {
                return (
                <div key={val.id || val.name}>
                    <div className="d-flex align-items-center">
                        <div className={"mb-2 mt-3 mr-2 " + (val.profileImageUrl ? "" : "d-none")} style={{height: '60px', width: '60px'}}>
                            <Image src={val.profileImageUrl} roundedCircle style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
                        </div>
                        <p className="mb-0 p-0 font-weight-bold">{val.name}</p>
                    </div>
                    <Card.Text className={(val.about ? "" : "d-none")}>
                        {val.about}
                    </Card.Text>
                </div>)

            } else {
                return (<div key={idx}></div>)
            }
        })}
        {/* {studioMode && hostData && (<>
            <div className="d-flex align-items-center">
                <div className={"mb-2 mt-3 mr-2 " + (hostData.profileImageUrl ? "" : "d-none")} style={{height: '60px', width: '60px'}}>
                    <Image src={hostData.profileImageUrl} roundedCircle style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
                </div>
                <p className="mb-0 p-0 font-weight-bold">{hostData.name}</p>
            </div>
            <Card.Text className={(hostData.about ? "" : "d-none")}>
                {hostData.about}
            </Card.Text>
        </>)} */}
    </>)

    return (
        <Card key={props.platformID} border='transparent' className='text-left p-0' style ={{width: '100%'}}>
            <Accordion>
            <Card.Body className='p-1'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div>
                        <Card.Text className="m-0 p-0 dateTimeText">
                            {props.datetime}
                        </Card.Text>
                        <Card.Title className='mb-1'>
                            {props.name || props.class_name}
                        </Card.Title>
                        {/* <h6 className="m-0 p-0 mb-1 font-weight-bold">
                            {hostData.name}
                        </h6> */}
                        <Card.Text className="m-0 p-0 font-weight-bold">
                            {props.hostName}
                            {/* {hostData.name} */}
                            {/* {props.instructor_name} */}
                            {/* {props.hostData && props.hostData.map((val, index) => {
                                return <span>{!studioMode && val.specialGuest ? "Special guest: " : ""}{val.name}{(props.hostData.length > index + 1) ? " & " : ""}</span>
                            })} */}
                        </Card.Text>
                        <Card.Text className="m-0 p-0 mb-2">
                            {props.location}
                        </Card.Text>
                        <Accordion.Toggle as={Button} variant="link" eventKey="0" className='primaryColor m-0 p-0'>
                            View Details
                        </Accordion.Toggle>
                    </div>
                    <div className="ml-2">
                        <Button className="primaryColor" style={{"whiteSpace": "nowrap"}} onClick={props.clickHandler}>{actionButtonText}</Button>
                    </div>
                </div>
                <div>
                    <Accordion.Collapse eventKey="0">
                        {classExtraDescription}
                    </Accordion.Collapse>
                </div>
            </Card.Body>

            </Accordion>
            {props.showDivider && (
                <hr />
            )}
        </Card>
    )
}

function ClassListFilters(props) {
    const {classes} = props
    const { register, handleSubmit, errors, control, setValue, getValues, watch } = useForm();


    const onSubmit = data => console.log(data);
    console.log(errors);

    const mapped = [{
        label: "All Class Types",
        value: ""
    }].concat(classes.map(val => {
        return {
            label: val.name,
            value: val.name
        }
    }))
    var classTypeOptions = _.map(
        _.uniq(
            _.map(mapped, function(obj){
                return JSON.stringify(obj);
            })
        ), function(obj) {
            return JSON.parse(obj);
        }
    );

    const mappedInstructors = [{
        label: "All Instructors",
        value: ""
    }].concat(classes.map(val => {
        if (val.hostName) {
            return {
                label: val.hostName,
                value: val.hostName
            }
            // return val.hostData.map(hData => {
                // return {
                //     label: hData.name,
                //     value: hData.name
                // }
            // }).flat()
        }
    })).flat() // JARCH -- instructors here.. 
    const instructorOptions = _.map(
        _.uniq(
            _.map(mappedInstructors, function(obj){
                return JSON.stringify(obj);
            })
        ), function(obj) {
            return JSON.parse(obj);
        }
    );
    
    return (

    <div className="row">
        <Form.Group className="col-md-6" controlId="exampleForm.ControlSelect1">
            <Controller
                // as={<Select isDisabled={disabled}/>}
                as={CustomReactSelect}
                options={classTypeOptions}
                control={control}
                setValue={setValue}
                getValues={getValues}
                placeholder={"All Class Types"}
                name={"classType"}
                isMulti={false}
                newSelection={ (x) => {
                    if (props.onSelectClassType) {
                        props.onSelectClassType(x)
                    }
                    console.log("new class type: ", x)

                }}
            />
        </Form.Group>
        <Form.Group className="col-md-6" controlId="exampleForm.ControlSelect2">
            <Controller
                // as={<Select isDisabled={disabled}/>}
                as={CustomReactSelect}
                options={instructorOptions}
                control={control}
                setValue={setValue}
                getValues={getValues}
                placeholder={"All Instructors"}
                name={"instructor"}
                isMulti={false}
                newSelection={ (x) => {
                    if (props.onSelectInstructor) {
                        props.onSelectInstructor(x)
                    }
                    console.log("new instructor type: ", x)

                }}
            />
        </Form.Group>

    </div>
    );
}

function ClassListSection(props) {

    const host = useQuery().get('host');
    const template = useQuery().get('template')

    const type = useQuery().get('type');
    if (type === "event") {
        console.log("Got the type events: ", type)
    }

    const location = useQuery().get('location');

    const {products, ondemand, challengeid} = props
    var emptyState = null
    if (challengeid) {
        emptyState = (
            <div>
                <h4 className="font-weight-bold">Coming soon</h4>
                {/* <h6>For now check out the content in ON-DEMAND &amp; RESOURCES</h6> */}
            </div>
        )
    } else {
        emptyState = (
            <div>
                <h4 className="font-weight-bold">No upcoming classes</h4>
                {/* <h6>For now check out the content in ON-DEMAND &amp; RESOURCES</h6> */}
            </div>
        )
    }

    
    const challengeWidget = useChallenge()
    const selectedChallenge = challengeWidget?.challenge
    const [selectedClassType, setSelectedClassType] = React.useState("")
    const [selectedInstructor, setSelectedInstructor] = React.useState("")
    const [numberOfClasses, setNumberOfClasses] = React.useState(10)
    const isLoadingClasses = useSelector(state => state.widget.isLoadingClasses)
    const allClasses = useSelector(state => state.widget.classes.filter(val => {
        if (challengeid) {
            if (val.challengeId === challengeid) {
                return true
            }
            if (selectedChallenge && selectedChallenge.listPublicLocationTypes && selectedChallenge.locationTypes.includes(val.location_type)) {
                if (val.challengeId && val.challengeId !== challengeid) {
                    return false
                }
                if ((selectedChallenge.startDate && selectedChallenge.startDate > val.start_time) || (selectedChallenge.startDate && selectedChallenge.endDate < val.start_time)) {
                    return false
                }
                return (val?.experience_type?.toLowerCase() !== "appointment")
            }
            return false
        } else if (val?.experience_type?.toLowerCase() === "appointment") {
            return false
        } else {
            return !val.challengeId
        }
    })).filter(val => {
        if (type) {
            return val.experience_type.toLowerCase() === type
        }
        if (location) {
            return val.location_type.toLowerCase() === location
        }
        if (template) {
            return val.service_id === template
        }
        return true
    }).filter(val => {
        if (host) {
            return val.host_ids.includes(host)
        }

        return true
    })
    const classes = allClasses.filter(val => {
        if (selectedClassType) {
            return val.name === selectedClassType || val.class_name === selectedClassType
        }
        if (selectedInstructor) {
            return val.hostName === selectedInstructor
            // return val.hostData?.name === selectedInstructor
        }
        return true
    })

    const instructor = useSelector(state => state.widget.instructor);
    const reservationsMap = useSelector(state => state.user.reservations.reduce((map, obj)=> {
        if (obj.serverReservationObjectId) {
            map[obj.serverReservationObjectId] = obj
        }
        return map
    },{}))
    const ownedOfferings = useSelector(state => state.user.ownedOfferings)
    const ownedChallenges = useSelector(state => state.user.ownedChallenges)
    classes.forEach(val => {
        const usersReservation = reservationsMap[val.platformID]
        if (usersReservation && !usersReservation.canceled) {
            val.reservation = usersReservation
        } else if (val.challengeId) {
            const owned = ownedOfferings[val.challengeId] ?? ownedChallenges[val.challengeId]
            if (owned) {
                val.reservation = owned
            }
        }
    })
    
    // var workoutTypes = ""
    if (instructor && instructor.instructorProfile && instructor.instructorProfile.workoutTypes && instructor.instructorProfile.workoutTypes.length > 0) {
        // console.log(user.instructorProfile.workoutTypes)
        // workoutTypes = user.instructorProfile.workoutTypes.joined(', ')
        // workoutTypes = 'Upcoming Digital Classes'
    }

    

    useEffect(() => {
        wakeupCheckout().then(res => {
            
        })
    }, [])

    useEffect(() => {
        if (instructor) {
            analytics.page({
                title: 'Class List'
            })
            analytics.track("Profile_view", {
                userId: instructor.platformID,
                name: instructor?.instructorProfile?.pageName ?? instructor.firstName
            })
        }
    }, [instructor])

    const router = useRouter()
    // console.log("Router: ", router)

    function stripTrailingSlash(str) {
        if(str.substr(-1) === '/') {
            return str.substr(0, str.length - 1);
        }
        return str;
    }

    const join = (base, path) => {
        return base.charAt(base.length-1) === '/'
          ? base.slice(0, -1) + path
          : base + '/' + path
    }

    function openClass(val) {
        // console.log(window.branch)
        analytics.track("reserveSpotSelected")
        if (true) { // user has in browser checkout turnedon ....
            
            router.push(`${stripTrailingSlash(router.match.url)}/checkout/${val.platformID}`)

            // props.classSelected(val)
            return
        }
        window.branch.link({
            tags: ['class'],
            channel: 'website',
            feature: 'widget',
            data: {
                shareType: "class",
                platformID: val.platformID
            }
        }, function(err, link) {
            if (link && window.location) {
                window.location.assign(link);
                // window.open(link);
            }
        });
        
    }

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })
    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday]',
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            lastWeek : '[last] dddd [at] LT',
            nextWeek : 'dddd [at] LT',
            sameElse : 'dddd MMM Do [at] LT'
        }
    });

    const classesByDay = _.groupBy(classes.slice(0, numberOfClasses), function (val) {
        return moment(val.start_time * 1000).startOf('day').format('LLLL')
    })
    function createCardForClass(val, showDivider) {
        var name = val.name || val.class_name
        let startTime = moment(val.start_time * 1000)
        let image = (val.images && val.images.length > 0) ? val.images[0] : ""
        let dateString = ""
        if (instructor.studioMode) {
            dateString = `${startTime.format('LT')} ${moment.tz(moment.tz.guess()).format('z')} • (${val.duration} min)`
        } else {
            dateString = startTime.calendar() + ` ${moment.tz(moment.tz.guess()).format('z')}` + ` • (${val.duration} min)`
            //+ ` with ${val.host_name}`
        }
        var priceString = "";
        if (val.price > 0 && val.purchase_type?.toLowerCase() === 'paid') {
            priceString = `$${val.price} • `
        } else if (val.isDonation || val.purchase_type?.toLowerCase() === 'donation') {
            priceString = "Sliding Scale • "
        } else if (val.price === 0 || val.purchase_type?.toLowerCase() === 'free') {
            priceString = ""
        }
        priceString = priceString + `(${val.duration} min)`
        if (val.challengeId) {
            priceString = null
            name = name + ` (${val.duration} min)`
        }
        const cantreservetheseclasses = ["Qks5jmZFhZMWJZwqqNMo","iuCUcdcDYnT3HVJs8Jw5","N45MGphdqLTrgftu19hD","LTsdwq9FMGVmeFbfotYy","tTorLTUY9JOWQnhthSq4","64bPKumVuUJqSkw9AqYi","Ck1Jlcors4akEJWWYAIP","ASNzfS5UByiUgleQTtpV","TeaoTfXYDTG2Yw9fq2Gi","RQlT0W346ijIqKQ3MjIG","ha2RLMqxlwGHQDhZcdxm","3wewQYeqCDzw2sCdta07","OknNWRb9TK2T6ZmkLCe4","mA1uZxiTs0B31607c485"
        ]
        var isFull = false
        if (val.max_capacity && val.total_booked && val.total_booked >= val.max_capacity) {
            isFull = true
        }
        if (cantreservetheseclasses.includes(val.id) || isFull) {
            val.classIsFull = true
        }

        let location = (<></>);
        switch (val.location_type) {
        case "inperson":
            if (["XS5S7T9KRFPR3gBo5KwGdun6P4J2", "TSu6fLqAkaboNwQ3Sb90wHlKfre2"].includes(val?.instructor_id ?? "")) {
                location = (<>
                    <span className="my-1">{val.location?.address ?? "In-Person"}</span>
                </>)
            } else {
                location = (<>
                    <span className="my-1">{val.location?.cityState ?? "In-Person"}</span>
                </>)
            }
            break
        default:
            location = (<>
                <span className="my-1">LIVESTREAM</span>
            </>)
            break
        }
        return (
            <ClassCard
                type={type}
                image={image}
                reservation={val.reservation}
                key={val.platformID}
                platformID={val.platformID}
                datetime={dateString}
                price={priceString}
                instructor_name={val.instructor_name}
                hostName={val.hostName}
                class_name={name}
                description={val.description || val.class_about}
                location={location}
                clickHandler={() => openClass(val)}
                full={val.classIsFull}
                studioMode={instructor?.studioMode ?? false}
                hostData={val.hostData ?? null}
                showDivider={showDivider}
            />
        )
        
    }


    return (
        <div
        textcolor="dark"
        size="md"
        className="py-1"
        >
        
        {instructor.studioMode && (
            <ClassListFilters
            classes={allClasses}
            onSelectClassType={(x) => {
                console.log("This class type: ", x)
                setSelectedClassType(x)
            }}
            // setSelectedClassType
            onSelectInstructor={(x) => setSelectedInstructor(x)}
            />
        )}
        {classes?.length === 0 && !isLoadingClasses && (
            <>
                {emptyState}
            </>
        )}
        {isLoadingClasses && (
            <div className="d-flex">

                <Spinner
                animation="border"
                size="sm"
                role="status"
                aria-hidden={true}
                className="ml-2 m-auto"
                >
                </Spinner>
            </div>

        )}
        <div className="text-center">
            {instructor.studioMode ? (
            <>
                {Object.keys(classesByDay).map((day) => {
                    const classesForThisDay = classesByDay[day]
                    const currentDay = moment(day, 'LLLL')
                    const lengthOfClasses = classesForThisDay.length
                    // const Date
                    return (
                    <div key={day}>
                        <div className="my-1 py-2 px-3 text-left border-top border-bottom daySeparator" 
                        style={{ marginLeft: '-1em', marginRight: '-1em'}}
                        >
                            <h6 className="m-0">{currentDay.format('dddd MMM Do')}</h6>
                        </div>
                        
                        {
                        classesForThisDay.map((val, index) => {

                            return createCardForClass(val, index !== lengthOfClasses - 1)
                            
                        })}
                        
                    </div>
                    )
                })}
            </>
            ) : (
            <>
                {classes.slice(0, numberOfClasses).map(val => {
                    return createCardForClass(val, true)
                })}
            </>
            )
                
            }

            {classes.length > numberOfClasses && (
                <div className="m-auto">
                    <Button
                    className="btn-link primaryColor"
                    onClick={() => {
                        setNumberOfClasses(numberOfClasses + 10)
                    }}>Load more</Button>
                </div>
            )}
        </div>
        
        </div>
    );
}

export default ClassListSection;
